module.exports = __webpack_public_path__ + "media/images/CeA-912fac5572bf938af812b36a922c4f7b.png";